const DEFAULT_MAXIMUM_PAGE_SIZE = 50;

export { DEFAULT_MAXIMUM_PAGE_SIZE };
